import { Cache } from "./cache";
import { DataService } from "../../service/data/data.service";
import { Observable } from "rxjs";
import { Document } from '@xanadu/model';

export class DataCache<T extends Document> extends Cache<T> {

    constructor(
        protected readonly type: new (x: any) => T,
        protected readonly dataService: DataService
    ) {
        super(type);
    }

    protected load(): Observable<T[]> {
        return this.dataService.all(this.type);
    }
}
